//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useContext, } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Navigate, useNavigate } from 'react-router-dom';

// ### MUI / STYLES ###
import { useTheme } from '@mui/material/styles';
import {
  Box,
} from '@mui/material';

// === COMPONENTS ===
import { FileList } from './FileList/FileList';
import { FileView } from './FileView/FileView';
import { TaskView } from './TaskView/TaskView';
import { RuleList } from './RuleList/RuleList';
import { RuleView } from './RuleView/RuleView';
import { ExpressionProvider } from './RuleView/components/ExpressionContext/ExpressionContext.jsx';

import { AppContext } from 'pages/App/components/AppContext/AppContext';

//#endregion

//-----------------------------------------------------------------
export function DocAnalytics() {
  //-----------------------------------------------------------------

  //#region [VALUES]
  
  const { user_details } = useContext( AppContext );

  const theme        = useTheme();
  const navigate     = useNavigate();

  const path_rule_list = '/rules';
  const path_rule_view = '/rules/:rule_id';
  const path_file_list = '/files';
  const path_file_view = '/files/:file_id';
  const path_task_view = '/files/:file_id/exceptions/:exception_id';
  const path_doct_view = '/files/:file_id/task';
  const path_misc      = '/*';
  const path_main      = '/main'; 
 
  const hasPermission = user_details.roles?.some((item) => item.RoleName === 'analyst');

  let page = localStorage.getItem('display_page');
  if( !page ) page = 'verify';

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      height: `calc(100% - 5rem)`,
      overflow  : 'hidden',
      'z-index' : '0',
      backgroundColor : theme.palette.background.primary[theme.palette.mode],
    },
  }

  //#endregion

  //#region [green] Events

  if( user_details.roles.length === 0 ) {
    return null;
  }

  if( !hasPermission ) {
    navigate( '/' + page );    
  }

  //#endregion

  //#region [Main] render information
  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box sx={_styles.container}>
        <Routes>
          <Route path={ path_rule_list } element={ <RuleList />  } />
          <Route path={ path_rule_view } element={ 
            <ExpressionProvider><RuleView /></ExpressionProvider>} />
          <Route path={ path_task_view } element={ <TaskView />  } />
          <Route path={ path_doct_view } element={ <TaskView />  } />
          <Route path={ path_file_view } element={ <FileView />  } />
          <Route path={ path_file_list } element={ <FileList />  } />
          <Route path={ path_misc      } element={ <Navigate to='files' replace /> } />
        </Routes>
      </Box>
    )
  }

  //-----------------------------------------------------------------
  function displayMain() {
    //-----------------------------------------------------------------
    return (
      <div style={{height: '100%', display: 'grid'}} >
        <FileList />
        <RuleList />
      </div>
    )
  }

  //#endregion

  return display();
}
